var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11726 7.6H17.3827C17.6211 7.6 17.8066 7.80723 17.7803 8.04417L16.5025 19.5442C16.48 19.7467 16.3088 19.9 16.105 19.9H7.39504C7.19122 19.9 7.02 19.7467 6.99749 19.5442L5.71971 8.04417C5.69338 7.80723 5.87886 7.6 6.11726 7.6Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9487 4.8H17.75C18.1642 4.8 18.5 5.13579 18.5 5.55C18.5 5.96421 18.1642 6.3 17.75 6.3H5.75C5.33579 6.3 5 5.96421 5 5.55C5 5.13579 5.33579 4.8 5.75 4.8H7.55125C7.64391 4.34355 8.04746 4 8.53125 4H14.9688C15.4525 4 15.8561 4.34355 15.9487 4.8Z",
    fill: "currentColor"
  })));
};
export default SvgDelete;